import React, { FC, ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { v4 as uuidv4 } from "uuid"
import { useSystemSettingsContext } from "../../system/providers/systemSettingsProvider"
import ControlledCheckbox, { Checkbox } from "../checkboxes/checkbox"
import { TabsType } from "./DefaultDictionaryCommandsPanel"
import styles from "./styles/BaseCommandsPanel.module.scss"

export interface ICommandState {
    disabled?: boolean
}

export type BaseCommandModeType = "view" | "search" | "edit"

export interface ICommand {
    iconButton: ReactNode | null
    text?: string
    state?: ICommandState
}

interface ICommandsPanelProps {
    groups: ICommand[][]
    groupRefs?: Array<React.RefObject<HTMLDivElement> | undefined>
}

export interface ICommandsPanelCheckboxProps {
    disabled: boolean
    onChecked: (checked: boolean) => void
    tabsType?: TabsType[]
    parentSelectedItem?: ISelectGridRow
    checked?: boolean
}

export const ShowDeletedCheckbox: FC<ICommandsPanelCheckboxProps> = (props) => {
    const { t } = useTranslation()

    if (props.tabsType && props.tabsType.includes("nomenclature")) {
        return (
            <ControlledCheckbox
                name={`showDeleted-${uuidv4()}`}
                label={t("general.deletedItemsCheckboxLabel")} //'Удаленные'
                disabled={props.disabled}
                parentSelectedItem={props.parentSelectedItem}
                onChange={(checked) => props.onChecked(checked)}
                checked={props.checked}
            />
        )
    }

    return <Checkbox name={`showDeleted-${uuidv4()}`} label={t("general.deletedItemsCheckboxLabel")} disabled={props.disabled} onChange={(checked) => props.onChecked(checked)} checked={props.checked} />
}

const CommandsPanelSeparator: FC = () => {
    return (
        <div className={styles.delimiter}>
            <span></span>
        </div>
    )
}

const BaseCommandsPanel: FC<ICommandsPanelProps> = (props) => {
    const commandPanelHeight = useSystemSettingsContext().CommandPanel

    return (
        <div className={styles.commandsPanel}>
            <div className={styles.control} style={{ height: commandPanelHeight }}>
                {props.groups.map((group, groupIndex) => {
                    const filteredGroup = group.filter((c) => c.iconButton !== null && !(c.iconButton as any)?.props?.disabled)

                    if (filteredGroup.length === 0) {
                        return null
                    }
                    return (
                        <React.Fragment key={groupIndex}>
                            <div ref={props.groupRefs?.[groupIndex]} className={styles.commandsGroup}>
                            {filteredGroup.map((c, index) => (
                                <React.Fragment key={index}>
                                    <div className={styles.controlPrimary}>{c.iconButton}</div>
                                    <div>{c.text}</div>
                                </React.Fragment>
                            ))}
                            </div>
                            {groupIndex < props.groups.length - 1 && filteredGroup.length > 0 && (
                                <div className={styles.controlDelimiter}>
                                    <CommandsPanelSeparator />
                                </div>
                            )}
                        </React.Fragment>
                    )
                })}
            </div>
        </div>
    )
}
export default BaseCommandsPanel
